module.exports = __webpack_public_path__ + "static/Muli-ExtraLight.f9b7a534.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-ExtraLight.ttf
// module id = 334
// module chunks = 114276838955818